import hotlines from "../services/hotlines";
import notification from "../services/notification";

const perPage = 10;

export default {
    namespaced: true,
    state: {
        error: false,
        errors: null,
        loading: false,
        notification: null,
        view: null,
        list: [],
        page: 1,
        perPage: 10,
        prevPage: null,
        nextPage: null,
        maxPage: null,
        startList: null,
        endList: null,
        message: null,
        uuid: null,
        hotline: {
            hotline: null,
            visibility: null
        }
    },
    mutations: {
        setList(state, response) {
            state.list = response.list;
            state.maxPage = response.max_page;
            state.nextPage = response.next_page;
            state.prevPage = response.prev_page;
            state.startList = state.page == 1 ? "1" : state.page * perPage + 1;
            state.endList = state.startList + perPage;
            state.message = response.message;
        },
        getNext(state) {
            state.page = state.nextPage;
        },
        getPrev(state) {
            state.page = state.prevPage;
        },
        getFirstPage(state) {
            state.page = 1;
        },
        setPage(state, page) {
            state.page = page;
        },
        setHotline(state, form) {
            state.hotline.hotline = form.hotline;
            state.hotline.visibility = form.visibility;
        },
        setUuid(state, uuid) {
            state.uuid = uuid;
        },
        loading(state, value = true) {
            state.loading = value;
        },
        errors(state, errors) {
            state.error = true;
            state.errors = errors.errors;
            state.loading = false;
        },
        setErrorDefault(state) {
            state.error = false;
            state.errors = null;
            state.loading = false;
        }
    },
    actions: {
        getFirstPage({ commit, dispatch }) {
            commit("getFirstPage");
            dispatch("getList");
        },
        getList: async ({ commit, state }) => {
            commit("loading");
            try {
                let response = await hotlines.getList(state.page);
                commit("setList", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        getNext({ commit, dispatch }) {
            commit("getNext");
            dispatch("getList");
        },
        getPrev({ commit, dispatch }) {
            commit("getPrev");
            dispatch("getList");
        },
        getHotline: async ({ commit, state }) => {
            commit("loading");
            try {
                let response = await hotlines.getInfo(state.uuid);

                commit("setHotline", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        createHotline: async ({ commit, state }) => {
            commit("setErrorDefault");
            commit("loading");
            try {
                let response = await hotlines.createHotline({
                    hotline: state.hotline.hotline,
                    visibility: state.hotline.visibility
                });
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(
                    errors.errors.hotline
                );
                // commit("loading", false);
                // commit("errors", errors);
            }
        },
        updateHotline: async ({ commit, state }) => {
            commit("setErrorDefault");
            commit("loading");
            try {
                let response = await hotlines.updateHotline(state.uuid, {
                    hotline: state.hotline.hotline,
                    visibility: state.hotline.visibility
                });
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(
                    errors.errors.hotline
                );
                // commit("loading", false);
                // commit("errors", errors);
            }
        },
        deleteHotline: async ({ commit, state }) => {
            commit("loading");
            try {
                let response = await hotlines.deleteHotline(state.uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                console.log('module: ', errors);
                commit("errors", errors);
                commit("loading", false);
            }
        }
    }
};
